<div class="form-group search-input position-relative" style="margin-bottom: 0!important;">
  <div class="position-relative">
    <input class="form-control selectdroupdown"
           autocomplete="off"
           aria-autocomplete="none"
           [placeholder]="placeholder"
           [style]="inputStyles"
           [class.error-input]="errorExists"
           [ngModel]="getInputModel()"
           (ngModelChange)="inputModelChangeEvent($event)"
           (selectItem)="selectItem($event)"
           (change)="prefetch()"
           [resultFormatter]="resultFormatter"
           (focus)="focus($event)"
           (click)="click$.next($any($event).target.value)"
           (blur)="focusout()"
           [ngbTypeahead]="suitableTerms$"
           [container]="'input'"

           #instance="ngbTypeahead"
    />
    <div class="spinner-border position-absolute" role="status"
         style="width: 1rem; height: 1rem; right: 10px; top: calc(50% - 0.5rem)"
         *ngIf="loadingModel"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
